import React, { FunctionComponent, ReactElement } from 'react';
import { useLocation } from 'react-router';
import ErrorPage from '@pages/ErrorPage';
import LocationState from '@interfaces/LocationState';

type PropsErrorHandled = {
  children: ReactElement;
};

const ErrorHandler: FunctionComponent<PropsErrorHandled> = ({ children }) => {
  const location = useLocation();
  console.log('ErrorHandler', location);
  const { state } = location;
  const { errorPageInfo } = (state as LocationState | undefined) ?? {};

  if (errorPageInfo) {
    const { responseStatus, title, description } = errorPageInfo;

    return (
      <ErrorPage
        responseStatus={responseStatus}
        title={title}
        description={description}
      />
    );
  }

  return children;
};

export default ErrorHandler;
